import React, { useEffect, useState } from "react";
import {
  Box,
  ButtonStyled,
  ButtonStyledTb,
  FormButtonStyled,
  FormEleWrapper,
  HeadingStyled,
  LabelStyled,
  SubHeadingStyled,
  TextStyled,
} from "../../../components/styled/Elements";
import { useTranslation } from "react-i18next";
import FloatingInput from "../../../components/common/inputFields/FloatingInput";
import { Camera, ProfileImgLarge } from "../../../components/styled/AllImages";
import { ProfileEditContainer } from "./styled";
import { Col, Form, Row } from "react-bootstrap";
import ValidatedInput from "../../../components/common/inputFields/ValidatedInput";
import { SelectionDropdown } from "../../../components/styled/FormElements";
import {
  cityList,
  OperateList,
  ProvinceList,
} from "../../../helpers/dummyConstants";
import PhoneInputField from "../../../components/common/inputFields/PhoneInput";
import { useForm } from "react-hook-form";
import UsersApi from "../../../services/api/usersApi";
import ValidationController from "../../../components/common/inputFields/ValidationController";
import { MultiSelectionDropdown } from "../../../components/common/dropdowns/MultiSelectDropdown";
import { emailRegex } from "../../../utils";
import ProfileApi from "../../../services/api/profileApi";
import { toast } from "react-toastify";
import { useUser } from "../../../context/userContext";
import { useNavigate } from "react-router-dom";

const PersonalInformation = () => {
  const { fetchUserInfo, user } = useUser();
  const navigate = useNavigate();
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const {
    register,
    control,
    watch,
    reset,
    formState: { errors },
    handleSubmit,
  } = useForm();
  const [cities, setCities] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [loading, setLoading] = useState(false);
  const isVisitorSpecialization =
    Number(user?.fal_information?.specialization) === 4;
  // Helper function to translate options
  const translateOptions = (options, t) =>
    options.map((option) => ({
      label: t(option.label), // Translate the label
      value: option.value,
    }));
  // Use helper function to translate each dropdown's options
  const ProvinceListTrans = translateOptions(ProvinceList, t);

  const getCities = async () => {
    try {
      const { data, code } = await UsersApi.getCitiesList();
      if (code === 200 && data?.length > 0) {
        setCities(
          data.map((city) => ({
            ...city,
            value: city?.id,
            label: language === "en" ? city?.name_en : city?.name_ar,
          }))
        );
      }
    } catch (error) {}
  };
  const getProvinces = async () => {
    try {
      const { data, code } = await UsersApi.getProvincesList();
      if (code === 200 && data?.length > 0) {
        setProvinces(
          data.map((province) => ({
            value: province?.id,
            label: language === "en" ? province?.name_en : province?.name_ar,
          }))
        );
      }
    } catch (error) {}
  };

  useEffect(() => {
    getProvinces();
    getCities();
  }, [language]);
  useEffect(() => {
    if (user) {
      reset({
        name: user.name,
        email: user.email,
        phone: user.phone,
        province: user.personal_information?.province,
        city_id: user.personal_information?.city_id,
        we_operate_in:
          user.personal_information?.we_operate_in_data.map((op) => op.id) ||
          [],
        years_of_experience: user?.personal_information?.years_of_experience,
        properties_sold: user?.personal_information?.properties_sold,
        about_me: user?.personal_information?.about_me,
      });
    }
  }, [user]);

  const onSubmit = async (formData) => {
    try {
      setLoading(true);
      const payload = { ...formData };
      if (isVisitorSpecialization) {
        payload.we_operate_in = [];
        payload.about_me = "";
      }
      const { code, message } = await ProfileApi.savePersonalInfo(payload);
      if (code === 200) {
        toast.success(t("personal_information_updated"));
        fetchUserInfo();
      }
      if (code === 100 || code === 204) {
        toast.error(message);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ProfileEditContainer>
        <HeadingStyled size="24px" className="editProfileHeading">
          {t("PersonalInformation")}
        </HeadingStyled>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Box className="profileFormContainerInner">
            <Row className="mt-3">
              <Col md={12}>
                <ValidatedInput
                  name="name"
                  type="input"
                  fieldType="text"
                  placeholder={t("RobertFox")}
                  label="FullName"
                  className=""
                  staric="staric"
                  register={register}
                  errors={errors}
                  validationRules={{
                    required: true,
                  }}
                />
              </Col>
              <Col md={12}>
                <ValidatedInput
                  name="email"
                  type="input"
                  fieldType="text"
                  placeholder="Email"
                  label="Email"
                  className=""
                  staric="staric"
                  register={register}
                  errors={errors}
                  validationRules={{
                    required: true,
                    pattern: {
                      value: emailRegex,
                      message: "invalidEmail",
                    },
                  }}
                />
              </Col>
              <Col md={12}>
                <PhoneInputField
                  name="phone"
                  label={"phone"}
                  placeholder="phone"
                  register={register}
                  control={control}
                  validationRules={{
                    required: true,
                  }}
                  className={"flex-wrap p-0"}
                  staric="staric"
                />
              </Col>
              <Col md={12}>
                <Box className="formEleContainer">
                  <LabelStyled className="labelForm">
                    {t("Province")}
                    <span className="staric">*</span>
                  </LabelStyled>
                  <ValidationController
                    name={"province"}
                    control={control}
                    errors={errors}
                    validationConfig={{
                      required: `fieldRequired`,
                    }}
                    renderer={({ field }) => (
                      <SelectionDropdown
                        name={field.name}
                        placeholder={t("SelectOne")}
                        options={provinces}
                        value={field.value}
                        onChange={(e) => field.onChange(e.target.value)}
                      />
                    )}
                  />
                </Box>
              </Col>
              <Col md={12}>
                <Box className="formEleContainer">
                  <LabelStyled className="labelForm">
                    {t("City")}
                    <span className="staric">*</span>
                  </LabelStyled>
                  <ValidationController
                    name={"city_id"}
                    control={control}
                    errors={errors}
                    validationConfig={{
                      required: `fieldRequired`,
                    }}
                    renderer={({ field }) => (
                      <SelectionDropdown
                        name={field.name}
                        placeholder={t("City")}
                        options={
                          cities && cities.length > 0
                            ? cities.filter(
                                (city) => city?.region_id == watch("province")
                              )
                            : []
                        }
                        value={field.value}
                        onChange={(e) => field.onChange(e.target.value)}
                      />
                    )}
                  />
                </Box>
              </Col>
              {!isVisitorSpecialization && (
              <Col md={12}>
                <Box className="formEleContainer">
                  <LabelStyled className="labelForm">
                    {t("WeOperatein")}
                    <span className="staric">*</span>
                  </LabelStyled>
                  <ValidationController
                    name={"we_operate_in"}
                    control={control}
                    errors={errors}
                    validationConfig={{
                      required: `fieldRequired`,
                    }}
                    renderer={({ field }) => (
                      <MultiSelectionDropdown
                        name={field.name}
                        placeholder={t("SelectOne")}
                        options={cities}
                        value={field.value || []}
                        onChange={(selected) => field.onChange(selected)}
                      />
                    )}
                  />
                </Box>
              </Col>
              )}
              <Col md={12}>
                <ValidatedInput
                  name="years_of_experience"
                  type="input"
                  fieldType="number"
                  placeholder="AddExperience"
                  label="YearsofExperience"
                  className=""
                  // staric="staric"
                  innerTxt={t("Years")}
                  register={register}
                  errors={errors}
                  validationRules={{
                    required: false,
                  }}
                />
              </Col>
              <Col md={12}>
                <ValidatedInput
                  name="properties_sold"
                  type="input"
                  fieldType="text"
                  placeholder="AddNoSoldProperties"
                  label="PropertiesSold"
                  className=""
                  // staric="staric"
                  register={register}
                  errors={errors}
                  validationRules={{
                    required: false,
                  }}
                />
              </Col>
              {!isVisitorSpecialization && (
              <>
              <Col md={12}>
                <ValidatedInput
                  name="about_me"
                  type="textarea"
                  fieldType="text"
                  placeholder={"Writeaboutyourself"}
                  label="Aboutme"
                  className="combined"
                  register={register}
                  errors={errors}
                  validationRules={{
                    required: false,
                    maxLength: {
                      value: 250,
                      message: "maximum_250_characters_allowed",
                    },
                  }}
                />
              </Col>
              <Col md={12}>
                <TextStyled>{t("Briefdescriptionyourprofile")}</TextStyled>
              </Col>
              </>
              )}
            </Row>
            <Box className="formBtns">
              <ButtonStyledTb
                className="nextStepBtn"
                type="button"
                bg="var(--white)"
                border="var(--border)"
                color="var(--darkGrey)"
                onClick={() => navigate("/my-profile")}
              >
                {t("Cancel")}
              </ButtonStyledTb>
              <FormButtonStyled
                type="submit"
                bg="var(--themeColorSecondary)"
                disabled={loading}
                isLoading={loading}
                label={t("Update")}
              />
            </Box>
          </Box>
        </Form>
      </ProfileEditContainer>
    </>
  );
};

export default PersonalInformation;
